<template>
    <div>
        <a-input placeholder="配置编码" v-model="value" @click="handleOpen" style="width:180px;" :readOnly="true" >
            <a-icon title="取消选择" slot="addonAfter" v-if="value"  @click="handleCancleSelect" type="close-circle" class="btnIcon" />
            <a-icon v-else slot="addonAfter" @click="handleOpen" title="点击选择" class="btnIcon" type="select"  />
        </a-input>

        <a-modal :title="title" :visible="isShow" :confirm-loading="confirmLoading" width="750px" @cancel="handleCancel">
            <div style="padding-bottom:50px;">
                <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSearch">
                    <a-form-item label="所属目录">
                        <catalog :platformcode="platformcode"  @catalogcodechange="handleCatlogChange" ></catalog>
                    </a-form-item>

                    <a-form-item label="关键字">
                        <a-input v-model="searchP.keyword" placeholder="关键字" allow-clear ></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-button type="primary" @click="handleSearch">查询</a-button>
                    </a-form-item>
                </a-form>

                <a-table id="myServiceTable" :columns="columns" :data-source="tableData" :pagination="false" :loading="tloading" rowKey="configcode"
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:rowsType}">
                </a-table>
                <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
                    :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
            </div>

            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
                    确定
                </a-button>
            </template>
        </a-modal>
    </div>

</template>
<script>
import catalog from '../com/catalog'
let pagination ={
    page:1,
    pageSize:10,
    total:0
};
const columns = [
    {
        title: "配置编码",
        dataIndex: "configcode",
        align: "center",
        width:100,
        ellipsis: true,
    },

    {
        title: "配置名称",
        dataIndex: "configname",
        align: "center",
        width:120,
        ellipsis: true,
    },
    {
        title: "目录",
        dataIndex: "catalogname",
        align: "center",
        width:100,
        ellipsis: true,
    },
];
export default {
    data() {
        return {
            title:'选择配置编码',
            confirmLoading: false,
            formLoading:false,
            isShow:false,
            form: this.$form.createForm(this),
            searchP:{
                platformcode:'',
                catalogcode:'',
                keyword:'',
                platformlist:[]
            },
            columns,
            tableData:[],
            tloading:false,
            pagination,
            ordercoloum:'total',
            orderstr:'desc',
            selectedRowKeys: [],
            rowsType:'radio',
            platformcode:'',
        }
    },
    model:{
        prop:'value',
        event:'change'
    },

    props:{
        value:String,
    },
    methods: {
        setPlatform(v){
            this.platformcode = v;
        },
        handleCancleSelect(){
            this.$emit('change','');
            this.selectedRowKeys = [];
        },
        handleOk(){
            if(this.selectedRowKeys.length > 0){
                this.$emit('change',this.selectedRowKeys[0]);
            }
            this.handleCancel();
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        handleCatlogChange(v){
            this.searchP.catalogcode = v
        },
        handleCancel(){
            this.searchP = {
                platformcode:'',
                catalogcode:'',
                keyword:'',
                platformlist:[]
            },
            this.isShow = false
        },
        handleOpen(){
            this.isShow = true
            this.getAppSumData();
        },
        handleSearch(){
            this.pagination.page = 1;
            this.getAppSumData();
        },
        getAppSumData(){
            this.searchP.platformcode = this.platformcode;
            let that = this
            let params = {
                platformcode:that.searchP.platformcode,
                keyword:that.searchP.keyword,
                catalogcode:that.searchP.catalogcode,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "cloudconfig/queryconfiginfopage",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.tableData = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },

    },
    mounted() {
        
    },
    components:{
        catalog
    },

};
</script>

<style scoped>
    .btnIcon{
        width:26px;
        cursor:pointer;
        color: rgb(24, 144, 255);
    }

    #myServiceTable{
        margin-top: 10px;
    }

</style>
